import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {SiteClicksData, YandexMetricsParams} from "../types/yandex-data-check.types";
import {RecordData} from "../../../../types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class YandexDataCheckApiService {
  private http: HttpClient = inject(HttpClient);

  public getYandexMetrics({ path, id }: YandexMetricsParams): Observable<SiteClicksData> {
    return this.http.get<SiteClicksData>(`${baseUrl}/${path}/check-yandex/${id}`);
  }

  public updateYandexMetrics({ path, id }: YandexMetricsParams): Observable<RecordData> {
    return this.http.post<RecordData>(`${baseUrl}/${path}/update-yandex/${id}`, {});
  }
}
